/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1CourseregistrationDocumentStatus202,
  PostApiV1CourseregistrationDocumentStatus400,
  PostApiV1CourseregistrationDocumentStatus401,
  PostApiV1CourseregistrationDocumentStatus500,
  PostApiV1CourseregistrationDocumentStatusMutationRequest,
  PostApiV1CourseregistrationDocumentStatusMutationResponse,
} from "../../types/courseRegistrationDocumentController/PostApiV1CourseregistrationDocumentStatus.ts";
import { courseRegistrationDocumentStatusRequestViewModelSchema } from "../courseRegistrationDocumentStatusRequestViewModelSchema.ts";
import { courseRegistrationDocumentStatusResponseViewModelSchema } from "../courseRegistrationDocumentStatusResponseViewModelSchema.ts";

/**
 * @description (Accepted) Requisição aceita.
 */
export const postApiV1CourseregistrationDocumentStatus202Schema = z.lazy(
  () => courseRegistrationDocumentStatusResponseViewModelSchema,
) as unknown as ToZod<PostApiV1CourseregistrationDocumentStatus202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1CourseregistrationDocumentStatus400Schema =
  z.any() as unknown as ToZod<PostApiV1CourseregistrationDocumentStatus400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1CourseregistrationDocumentStatus401Schema =
  z.any() as unknown as ToZod<PostApiV1CourseregistrationDocumentStatus401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1CourseregistrationDocumentStatus500Schema =
  z.any() as unknown as ToZod<PostApiV1CourseregistrationDocumentStatus500>;

export const postApiV1CourseregistrationDocumentStatusMutationRequestSchema =
  z.lazy(
    () => courseRegistrationDocumentStatusRequestViewModelSchema,
  ) as unknown as ToZod<PostApiV1CourseregistrationDocumentStatusMutationRequest>;

export const postApiV1CourseregistrationDocumentStatusMutationResponseSchema =
  z.lazy(
    () => postApiV1CourseregistrationDocumentStatus202Schema,
  ) as unknown as ToZod<PostApiV1CourseregistrationDocumentStatusMutationResponse>;
